export default __webpack_public_path__ + "static/media/(14).5d68c70d.jpg";